export default "__VITE_ASSET__CdxdRvM0__"